import * as React from "react";
import {CommonHelpers, PremiumType, UPFRONT_PAYMENT_THRESHOLD} from "@ferry/journey-services";
import {MtaSuccessModalWording} from "./MtaSuccessModalWording";
import {IFactors} from "./GeneratorInputTypes";
import {EditCarMtaSuccessModalWordingGenerator} from "./EditCarMtaSuccessModalWordingGenerator";
import * as successModals from "../../../../../../components/modals/SuccessModalRenderers";

export interface IVehicle {
    registrationNumber: string | null;
    make: string | null;
    model: string | null;
}

export class ReplaceCarMtaSuccessModalWordingGenerator {

    public static generateModalWording = (oldVehicle: IVehicle, newVehicle: IVehicle, factors: IFactors, payFullPrice: boolean,
                                          cardNumber: string, agreeToReuseCardDetails: boolean, interaction: any, previousMonthlyPremium: any, instalmentsNotPaidOff: boolean, renewalPremium: any): MtaSuccessModalWording => {

        const premiumType: PremiumType = PremiumType[factors.premiumType as keyof typeof PremiumType];

        let modalTitle: React.ReactNode;
        let modalBody: React.ReactNode;

        const {addedDrivers, removedDrivers} = CommonHelpers.getRemovedAndAddedDrivers(interaction.additionalDrivers);

        if (factors.additionalPremium > 0 && (premiumType === PremiumType.annual || payFullPrice)) {
            modalTitle = "Payment was successful";
            const modalBodyContent = ReplaceCarMtaSuccessModalWordingGenerator.generateModalBody(oldVehicle, newVehicle, addedDrivers, removedDrivers);
            modalBody = successModals.paymentSuccessfulAdditionalPremiumModal(factors.additionalPremium, cardNumber, modalBodyContent, agreeToReuseCardDetails, renewalPremium);
        } else if (factors.additionalPremium > 0 && factors.upfrontPaymentAmount >= UPFRONT_PAYMENT_THRESHOLD && !payFullPrice) {
            modalTitle = "Payment was successful";
            const modalContent = ReplaceCarMtaSuccessModalWordingGenerator.generateModalBody(oldVehicle, newVehicle, addedDrivers, removedDrivers);
            modalBody = successModals.paymentSuccessfulAdditionalPremiumMonthlyModal(factors.upfrontPaymentAmount, factors.monthlyPaymentSpreadAmount, cardNumber, modalContent, agreeToReuseCardDetails, renewalPremium);
        } else if (factors.additionalPremium > 0 && factors.upfrontPaymentAmount < UPFRONT_PAYMENT_THRESHOLD && !payFullPrice) {
            modalTitle = "Your payment plan has been updated";
            modalBody = successModals.paymentPlanUpdatedAdditionalPremiumModal(factors.monthlyPaymentSpreadAmount, factors.monthlyPremium, previousMonthlyPremium, renewalPremium);
        } else if (factors.amountToRefund > 0 && premiumType === PremiumType.monthly && factors.monthlyPremium !== 0) {
            if (instalmentsNotPaidOff) {
                modalTitle = "Your payment plan has been updated";
            } else {
                modalTitle = "Your refund is on the way";
            }
            modalBody = successModals.paymentPlanUpdatedRefundModal(factors.amountToRefund, factors.monthlyPremium, previousMonthlyPremium, instalmentsNotPaidOff, renewalPremium);
        } else if (factors.amountToRefund > 0) {
            modalTitle = "Your refund is on the way";
            const modalContent = ReplaceCarMtaSuccessModalWordingGenerator.generateModalBody(oldVehicle, newVehicle, addedDrivers, removedDrivers);
            modalBody = successModals.paymentSuccessfulRefundModal(factors.amountToRefund, modalContent, renewalPremium);
        } else {
            modalTitle = "All done";
            modalBody = (
                <p className="font-weight-extra-light">
                    We’ve saved your changes, and there’s no extra cost{" "}
                    {ReplaceCarMtaSuccessModalWordingGenerator.generateModalBody(oldVehicle, newVehicle, addedDrivers, removedDrivers)}
                </p>
            );
        }

        return new MtaSuccessModalWording(modalTitle, modalBody, EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle(), EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody());
    }

    private static readonly generateModalBody = (oldVehicle: any, newVehicle: any, addedDrivers: any[], removedDrivers: any[]) => {
        const hasAddedDrivers = addedDrivers.length > 0;
        const hasRemovedDrivers = removedDrivers.length > 0;
        return <>
            <span className="font-weight-semi-bold">
                            for replacing {oldVehicle.make}, {oldVehicle.model} (
                {oldVehicle.registrationNumber}) with {newVehicle.make}, {newVehicle.model} (
                {newVehicle.registrationNumber}){hasAddedDrivers || hasRemovedDrivers ? "" : "."}
                {hasAddedDrivers && <p className="mb-0"> and to add additional{' '}
                    {addedDrivers.length === 1 ? 'driver' : 'drivers'} {addedDrivers} to{' '}
                    <b>{newVehicle.make}, {newVehicle.model} ({newVehicle.registrationNumber})</b>{hasRemovedDrivers ? "" : "."}
                </p>}
                {hasRemovedDrivers && <p className="mb-0"> and to remove{' '}
                    {removedDrivers.length === 1 ? 'driver' : 'drivers'} {removedDrivers}.
                </p>}
            </span>
        </>
    }
}
